import { Link } from 'gatsby';
import gsap from 'gsap';
import React, { useEffect, useRef } from 'react';
import { disablePageScroll, enablePageScroll } from 'scroll-lock';
import { menuWrapper, navList, show } from './NavDrawer.module.scss';

const NavDrawer = ({ navDrawerOpen, setNavDrawerOpen }) => {
  const navRef = useRef(null); // A wrapper so we can use querySelectorAll

  const navTlRef = useRef();
  useEffect(() => {
    let navContext = gsap.context(() => {
      navTlRef.current = gsap.timeline({ paused: true });
      gsap.set('ul', { autoAlpha: 0, y: 50 }); // using autoAlpha to prevent keyboard focus
      gsap.set('li', { opacity: 0, y: 50 });

      navTlRef.current
        .to(navRef.current, { opacity: 1, duration: 0.3 })
        .to('ul', { autoAlpha: 1, y: 0, duration: 0.5, ease: 'power3.out' })
        .to(
          'li',
          {
            opacity: 1,
            y: 0,
            duration: 0.5,
            stagger: 0.05,
            ease: 'power3.out',
          },
          '-=0.3'
        );
    }, navRef);
    return () => {
      // TODO does this actually do anything since the timeline is in a ref?
      navContext.revert();
    };
  }, []);

  useEffect(() => {
    if (navDrawerOpen) {
      disablePageScroll(navRef.current); // continue to allow scrolling on navRef.current
      navTlRef.current.play();
    } else {
      enablePageScroll(navRef.current);
      navTlRef.current.reverse();
    }
  }, [navDrawerOpen]);

  // FIXME this if from Free & Equal, but it feels broken, the menu closes unintentionally
  // I can't find a good tutorial on how to improve it... focus loop? arrow keys?
  const closeIfTabAway = () => {
    setTimeout(() => {
      if (!navRef.current?.contains(document.activeElement)) {
        setNavDrawerOpen(false);
      }
    }, 200); // setTimeout necessary bc onBlur always returns <body> otherwise
  };
  return (
    <div
      className={`pagePaddingTop ${menuWrapper} ${navDrawerOpen ? show : ''}`}
      ref={navRef}
      data-scroll-lock-scrollable
    >
      <ul
        className={`${navList} 
        `}
        aria-label="Main Navigation"
      >
        <li>
          <Link
            to={`/`}
            onClick={() => setNavDrawerOpen(false)}
            onBlur={closeIfTabAway}
            className={`h2`}
            activeClassName={`activePage`} // this also adds aria-current="page"
          >
            Home
          </Link>
        </li>
        <li>
          <Link
            to={`/work`}
            onClick={() => setNavDrawerOpen(false)}
            onBlur={closeIfTabAway}
            className={`h2`}
            activeClassName={`activePage`}
            partiallyActive={true} // allow anchors
          >
            Work
          </Link>
        </li>
        <li>
          <Link
            to={`/approach`}
            onClick={() => setNavDrawerOpen(false)}
            onBlur={closeIfTabAway}
            className={`h2`}
            activeClassName={`activePage`}
            partiallyActive={true} // allow anchors
          >
            Approach
          </Link>
        </li>
        <li>
          <Link
            to={`/services`}
            onClick={() => setNavDrawerOpen(false)}
            onBlur={closeIfTabAway}
            className={`h2`}
            activeClassName={`activePage`}
            partiallyActive={true} // allow anchors
          >
            Services
          </Link>
        </li>
        <li>
          <Link
            to={`/about`}
            onClick={() => setNavDrawerOpen(false)}
            onBlur={closeIfTabAway}
            className={`h2`}
            activeClassName={`activePage`}
            partiallyActive={true} // allow anchors
          >
            About Us
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default NavDrawer;
